import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "signin-container" }
const _hoisted_3 = {
  key: 0,
  class: "branding"
}
const _hoisted_4 = { class: "logo logo--lg" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "form-fields" }
const _hoisted_7 = { class: "actions" }
const _hoisted_8 = { class: "signin-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_FormInput = _resolveComponent("FormInput")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Form = _resolveComponent("Form")!
  const _component_ShadowContainer = _resolveComponent("ShadowContainer")!
  const _component_unauthenticated_layout = _resolveComponent("unauthenticated-layout")!

  return (_openBlock(), _createBlock(_component_unauthenticated_layout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.logoUrl)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, [
                  _createElementVNode("img", {
                    class: "icon",
                    src: _ctx.logoUrl,
                    alt: ""
                  }, null, 8, _hoisted_5)
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_ShadowContainer, null, {
            default: _withCtx(() => [
              _cache[4] || (_cache[4] = _createElementVNode("h4", null, "Create a new password", -1)),
              _cache[5] || (_cache[5] = _createElementVNode("p", { class: "detail" }, " Your Password must have a minimum of 8 characters and at least two of the following, uppercase, lowercase letter, number, special characters. ", -1)),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_Form, {
                  modelValue: _ctx.model,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model) = $event)),
                  errors: _ctx.errors,
                  "onUpdate:errors": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.errors) = $event)),
                  schema: _ctx.rules
                }, {
                  default: _withCtx(({ handleInputChange, isValid }) => [
                    _createVNode(_component_FormInput, {
                      id: "newPassword",
                      name: "newPassword",
                      label: "New Password",
                      type: _ctx.passwordType('newPassword'),
                      value: _ctx.model.newPassword,
                      error: _ctx.errors['newPassword'],
                      onChange: handleInputChange,
                      onEnter: _ctx.handleSubmit,
                      onClickAppendIcon: _cache[0] || (_cache[0] = ($event: any) => (_ctx.togglePasswordVisibility('newPassword'))),
                      hideLabelOnFocus: "",
                      required: ""
                    }, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: "lock" })
                      ]),
                      append: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, {
                          icon: _ctx.passwordIcon('newPassword')
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["type", "value", "error", "onChange", "onEnter"]),
                    _createVNode(_component_FormInput, {
                      id: "confirmNewPassword",
                      name: "confirmNewPassword",
                      label: "Confirm New Password",
                      type: _ctx.passwordType('confirmNewPassword'),
                      value: _ctx.model.confirmNewPassword,
                      error: _ctx.errors['confirmNewPassword'],
                      onChange: handleInputChange,
                      onEnter: _ctx.handleSubmit,
                      onClickAppendIcon: _cache[1] || (_cache[1] = ($event: any) => (
                    _ctx.togglePasswordVisibility('confirmNewPassword')
                  )),
                      hideLabelOnFocus: "",
                      required: ""
                    }, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: "lock" })
                      ]),
                      append: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, {
                          icon: _ctx.passwordIcon('confirmNewPassword')
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["type", "value", "error", "onChange", "onEnter"]),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_Button, {
                          variant: _ctx.getVariant,
                          text: "Change Password",
                          block: "",
                          disabled: !isValid,
                          onClick: _ctx.handleSubmit
                        }, null, 8, ["variant", "disabled", "onClick"])
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "errors", "schema"])
              ])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}